var map = {
	"./404.svg": 505,
	"./404_en.svg": 605,
	"./PDF.svg": 5315,
	"./about_img.svg": 1546,
	"./activities.svg": 2308,
	"./arrow-down-s-line.svg": 8722,
	"./arrow-left-line.svg": 2335,
	"./arrow-left-s-line.svg": 7331,
	"./arrow_left_line.svg": 5723,
	"./arrow_white.svg": 1784,
	"./asc.svg": 138,
	"./automation.svg": 3754,
	"./back_img_icon.svg": 7978,
	"./bale.svg": 2713,
	"./bug_security _white.svg": 9454,
	"./bug_security.svg": 8492,
	"./bug_vulnerabilities.svg": 6516,
	"./bug_vulnerabilities_white.svg": 9726,
	"./certificates.svg": 3639,
	"./checkbox-circle-fill.svg": 6805,
	"./checkbox-circle-line.svg": 9707,
	"./checked.svg": 9406,
	"./close-menu.svg": 3283,
	"./close.svg": 5837,
	"./cloud.svg": 1326,
	"./cloud_app_download.svg": 145,
	"./cloud_buy_download.svg": 5906,
	"./cloud_file_select.svg": 5526,
	"./cloud_free_download.svg": 4706,
	"./configuration_analysis.svg": 7748,
	"./dashboard-2-fill.svg": 6662,
	"./dashboard-line.svg": 6660,
	"./desc.svg": 9180,
	"./emulator_error.svg": 6513,
	"./facebook.svg": 3479,
	"./fave_icon.svg": 2325,
	"./fax.svg": 7564,
	"./features.svg": 5818,
	"./file_search.svg": 9460,
	"./generate_PDF_output.svg": 2707,
	"./github.svg": 7394,
	"./google.svg": 3486,
	"./green_logo.svg": 8945,
	"./home-fill-blue.svg": 5393,
	"./home-fill.svg": 5072,
	"./home.svg": 4174,
	"./home_header.svg": 8346,
	"./instagram.svg": 5373,
	"./library.svg": 6988,
	"./linkedin.svg": 6049,
	"./links.svg": 1278,
	"./login_icon.svg": 150,
	"./logo_main_other.svg": 1065,
	"./logout-box-line.svg": 5824,
	"./mail-fill.svg": 4136,
	"./mail.svg": 9814,
	"./main_logo.svg": 3602,
	"./malware.svg": 9588,
	"./manual_analysis.svg": 257,
	"./mark.svg": 6180,
	"./more_info.svg": 7171,
	"./not_found.svg": 8087,
	"./not_found_result.svg": 5549,
	"./open-menu.svg": 6757,
	"./panel_expire.svg": 2311,
	"./panel_planname.svg": 1334,
	"./panel_scan.svg": 7933,
	"./panel_upload.svg": 717,
	"./permission.svg": 5034,
	"./phone-fill.svg": 9405,
	"./phone.svg": 8726,
	"./phone_conUs.svg": 2748,
	"./provide_solution.svg": 8536,
	"./providers.svg": 3723,
	"./receivers.svg": 3079,
	"./rescan.svg": 9823,
	"./rest_api.svg": 2316,
	"./rotate-lock-fill.svg": 5460,
	"./run_app.svg": 6642,
	"./sandbox.svg": 5024,
	"./search-icon.svg": 5691,
	"./search.svg": 4343,
	"./search_total_scan.svg": 2680,
	"./search_total_scan_month.svg": 1503,
	"./search_total_scan_week.svg": 6231,
	"./services.svg": 1315,
	"./shopping-bag-fill.svg": 7272,
	"./specialized_report.svg": 2815,
	"./static_analysis.svg": 7606,
	"./success_checkbox_amulator.svg": 1526,
	"./support_programming.svg": 9598,
	"./tlg.svg": 9910,
	"./twitter.svg": 8592,
	"./user.svg": 698,
	"./user_panel_emulator_link.svg": 6932,
	"./user_panel_time.svg": 151,
	"./vira_logo_green.svg": 9299,
	"./vira_white.svg": 4973,
	"./vulnerability_identification.svg": 7880,
	"./vulns_library.svg": 9201,
	"./warning_blue.svg": 2440,
	"./warning_red.svg": 6881,
	"./warning_yellow.svg": 5572,
	"./white_logo_main.svg": 6312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;